import { QueryClient } from "@tanstack/react-query";

/**
 * Every query behind thread state: the list, the record, the supplier thread,
 * and the unread badge. Reading, closing and reopening each move more than one
 * of them — refreshing the list but not the badge leaves a count the user has
 * already cleared.
 */
const THREAD_QUERY_KEYS = [
  "ThreadsInfiniteList.Infinite",
  "ThreadUnreadCount",
  "SupplierThread",
  "Thread",
];

/** What a row watches to know it is waiting on something it was asked to do. */
export const THREAD_ROW_MUTATION_KEY = ["thread", "row"];

/**
 * Refetches everything a thread change moves.
 *
 * Return it from the mutation's onSettled. React Query waits on it before
 * settling, so the mutation — and the row watching it — stays pending until the
 * lists agree with what was asked for.
 *
 * A run of actions refetches once per action. Each invalidation cancels the
 * refetch before it rather than racing it, and a cancelled one keeps none of
 * its pages, so only the last answer is ever the one on screen.
 */
export function invalidateThreadQueries(queryClient: QueryClient) {
  return Promise.all(
    THREAD_QUERY_KEYS.map((queryKey) =>
      queryClient.invalidateQueries({ queryKey: [queryKey], exact: false }),
    ),
  );
}
